export enum InvestigationSupplementaryAssignee {
	Investigator = 1,
	Supervisor = 2,
}
